export const appMenuTranslationsEn = {
  users: 'Users',
  leads: 'Leads',
  businesspartners: 'Business partners',
  customers: 'Customers',
  employees: 'Employees',
  organizations: 'Organizations',
  dispatching: 'Dispatching',
  ratings: 'Ratings',
  accounting: 'Accounting',
  analysis: 'Analysis',
  admin: 'Admin',
  tickets: 'Tickets',
  organization: 'Organization',
  appointments: 'Appointments',
} as const;
